import {NgModule} from "@angular/core";
import {CommonModule, NgOptimizedImage} from "@angular/common";
import {ChangePasswordComponent} from "./generic-account-card/components/change-password/change-password.component";
import {LocationActionComponent} from "./locations/location-action/location-action.component";
import {LogsReportDialogComponent} from "./generic-account-card/components/logs-report-dialog/logs-report-dialog.component";
import {UserActionDialogComponent} from "./team/user-action/user-action-dialog.component";
import {WhitelistDialogComponent} from "./whitelist/whitelist-dialog/whitelist-dialog.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {UsageReportDialogComponent} from "./generic-account-card/components/usage-report-dialog/usage-report-dialog.component";
import {OrganizationUsageReportDialogComponent} from "./generic-account-card/components/organization-usage-report-dialog/organization-usage-report-dialog.component";
import {SettingsRoutingModule} from "./settings-routing.module";
import {MatButtonModule} from "@angular/material/button";
import {MatMenuModule} from "@angular/material/menu";
import {LocationsComponent} from "./locations/locations.component";
import {WhitelistComponent} from "./whitelist/whitelist.component";
import {InvoicesComponent} from "./invoices/invoices.component";
import {HistoryComponent} from "./history/history.component";
import {MatInputModule} from "@angular/material/input";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {GenericAccountCardComponent} from "./generic-account-card/generic-account-card.component";
import {FileUploadModule} from "ng2-file-upload";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatIconModule} from "@angular/material/icon";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {SharedModule} from "../../shared/shared.module";
import {LocationBadgeComponent} from "./team/location-badge/location-badge.component";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {
    ChangeAccountInformationDialogComponent
} from "./generic-account-card/components/change-account-information-dialog/change-account-information-dialog.component";
import {
    AccountInformationFormComponent
} from "./generic-account-card/components/change-account-information-dialog/components/account-information-form/account-information-form.component";
import {
    AddressFormComponent
} from "./generic-account-card/components/change-account-information-dialog/components/address-form/address-form.component";
import {SyncButtonComponent} from "./generic-account-card/components/sync-button/sync-button.component";
import {EmailTesterComponent} from "./email-tester/email-tester.component";
import {PushNotificationsComponent} from "./push-notifications/push-notifications.component";
import {MatRadioModule} from "@angular/material/radio";
import {MatDialogModule} from "@angular/material/dialog";

@NgModule({
  declarations: [
    ChangePasswordComponent,
    LocationActionComponent,
    LogsReportDialogComponent,
    UserActionDialogComponent,
    WhitelistDialogComponent,
    UsageReportDialogComponent,
    OrganizationUsageReportDialogComponent,
    LocationsComponent,
    WhitelistComponent,
    InvoicesComponent,
    HistoryComponent,
    GenericAccountCardComponent,
    ChangeAccountInformationDialogComponent,
    AccountInformationFormComponent,
    SyncButtonComponent,
    EmailTesterComponent,
    PushNotificationsComponent,
  ],
    imports: [
        CommonModule,
        SettingsRoutingModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatProgressSpinnerModule,
        MatButtonModule,
        MatMenuModule,
        MatInputModule,
        MatOptionModule,
        MatSelectModule,
        FormsModule,
        FileUploadModule,
        MatSlideToggleModule,
        NgOptimizedImage,
        MatIconModule,
        MatTooltipModule,
        MatCheckboxModule,
        SharedModule,
        LocationBadgeComponent,
        MatAutocompleteModule,
        AddressFormComponent,
        MatRadioModule,
        MatDialogModule,
    ],
  exports: [
    ChangePasswordComponent,
    LocationActionComponent,
    LogsReportDialogComponent,
    UserActionDialogComponent,
    WhitelistDialogComponent,
    UsageReportDialogComponent,
    OrganizationUsageReportDialogComponent,
    LocationsComponent,
    WhitelistComponent,
    InvoicesComponent,
    HistoryComponent,
    GenericAccountCardComponent,
  ],
})
export class SettingsModule {}
